import { render, staticRenderFns } from "./Dismissible.vue?vue&type=template&id=1a1bbb33&"
import script from "./Dismissible.vue?vue&type=script&lang=js&"
export * from "./Dismissible.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports